import createAPI from '../axios'

// 课程标准相关API
const courseStandardSkillsTraining = {
    courseStandard: {
        initCombo: config => createAPI('/KcbzzbSkillsTraining/initCombo', 'post', config),
        list: config => createAPI('/KcbzzbSkillsTraining/list', 'post', config),
        createCourseStandard: config => createAPI('/KcbzzbSkillsTraining/createCourseStandard', 'post', config),
        delRec: config => createAPI('/KcbzzbSkillsTraining/delRec', 'post', config),
        submitRec: config => createAPI('/KcbzzbSkillsTraining/submitRec', 'post', config),
    },
    KcbzKcbzzb: {
        queOne: config => createAPI('/KcbzzbSkillsTraining/queOne', 'post', config),
        update: config => createAPI('/KcbzzbSkillsTraining/update', 'post', config),
        findjxdg: config => createAPI('/KcbzzbSkillsTraining/findjxdg', 'post', config),
        findwnkcbz: config => createAPI('/KcbzzbSkillsTraining/findwnkcbz', 'post', config),
        importmsg: config => createAPI('/KcbzzbSkillsTraining/importmsg', 'post', config),
        //找到云班的历史课程标准 胡杰20210818
        findHistryKcbz: config => createAPI('/KcbzzbSkillsTraining/findHistryKcbz', 'post', config),
        //徐毅骏 20220120 导入前验证被导入课程与导入课程的数据
        checkBeforImport: config => createAPI('/KcbzzbSkillsTraining/checkBeforImport', 'post', config),
        //导出课程标准	WHY	20210610
        export: config => createAPI('/KcbzzbSkillsTraining/export', 'post', config),
        deleteFile: config => createAPI('/KcbzzbSkillsTraining/deleteFile', 'post', config),
        updateAuditState: config => createAPI('/KcbzzbSkillsTraining/updateAuditState', 'post', config),
    },
    KcbzKcnryyq: {
        queList: config => createAPI('/KcnryyqSkillsTraining/queOne', 'post', config),
        queList2: config => createAPI('/KcnryyqSkillsTraining/queOne2', 'post', config),
        queListByMsg: config => createAPI('/KcnryyqSkillsTraining/queListByMsg', 'post', config),
        addMsg: config => createAPI('/KcnryyqSkillsTraining/addMsg', 'post', config),
        deleteMsg: config => createAPI('/KcnryyqSkillsTraining/deleteMsg', 'post', config),//删除选中的知识点技能点
        addjobzsd: config => createAPI('/KcnryyqSkillsTraining/addjobzsd', 'post', config),//新增一级知识点技能点
        findyjzsdjnd: config => createAPI('/KcnryyqSkillsTraining/findyjzsdjnd', 'post', config),//查找所有的一级知识点或技能点
        findejzsdjnd: config => createAPI('/KcnryyqSkillsTraining/findejzsdjnd', 'post', config),//查找所有的二级知识点或技能点
        addejzsd: config => createAPI('/KcnryyqSkillsTraining/addejzsd', 'post', config),//新增二级知识点技能点
        findsjzsdjnd: config => createAPI('/KcnryyqSkillsTraining/findsjzsdjnd', 'post', config),//查找所有的二级知识点或技能点
        addsjzsd: config => createAPI('/KcnryyqSkillsTraining/addsjzsd', 'post', config),//新增三级知识点技能点
        editjobzsd: config => createAPI('/KcnryyqSkillsTraining/editjobzsd', 'post', config),//编辑一级知识点
        editejzsd: config => createAPI('/KcnryyqSkillsTraining/editejzsd', 'post', config),//编辑二级知识点
        editsjzsd: config => createAPI('/KcnryyqSkillsTraining/editsjzsd', 'post', config),//编辑三级知识点
    },
}

export default courseStandardSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/courseStandardSkillsTraining.js